import AdditionalFormFields from "../common-type";
import { Controller } from "react-hook-form";
import { TextInputFieldPropTypes } from "./text-input-field-types";

import TextInputField from "./text-input-field";

export const TextInputFormField = (props) => {
  const { name, defaultValue, control } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => {
        // field = { onChange, onBlur, value, name, ref }
        const { onChange, onBlur: rhfOnBlur, value } = field;

        // ① wrap the RHF onBlur…
        const combinedOnBlur = (e) => {
          rhfOnBlur(e); // ← keep RHF happy
          if (props.onBlur)
            // ← then your confirm
            props.onBlur(e);
        };

        return (
          <TextInputField
            {...props}
            value={value}
            onChange={onChange}
            onBlur={combinedOnBlur}
            error={error}
          />
        );
      }}
    />
  );
};

TextInputField.propTypes = {
  ...TextInputFieldPropTypes,
  ...AdditionalFormFields,
};

export default TextInputField;
